var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 28.5C57 44.2401 44.2401 57 28.5 57C12.7599 57 0 44.2401 0 28.5C0 12.7599 12.7599 0 28.5 0C44.2401 0 57 12.7599 57 28.5ZM5.7 28.5C5.7 41.0921 15.9079 51.3 28.5 51.3C41.0921 51.3 51.3 41.0921 51.3 28.5C51.3 15.9079 41.0921 5.7 28.5 5.7C15.9079 5.7 5.7 15.9079 5.7 28.5Z",
    fill: "#FBFBFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 28L22.5 37.5263L22.5 18.4737L39 28Z",
    fill: "#FBFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse25);
export default __webpack_public_path__ + "static/media/Ellipse 25.a70496d1bd74d0db8d8d279558e0426c.svg";
export { ForwardRef as ReactComponent };